
// Admin
  export const ADMIN_SUBSCRIPTIONPLAN_ACTIONS = {
    // list
    SUBSCRIPTIONPLAN_LIST_REQUEST: "ADMIN_SUBSCRIPTIONPLAN_LIST_REQUEST",
    SUBSCRIPTIONPLAN_LIST_RESPONSE: "ADMIN_SUBSCRIPTIONPLAN_LIST_RESPONSE",
    SUBSCRIPTIONPLAN_LIST_ERROR: "ADMIN_SUBSCRIPTIONPLAN_LIST_ERROR",

    // create
    SUBSCRIPTIONPLAN_REQUEST: "SUBSCRIPTIONPLAN_REQUEST",
    SUBSCRIPTIONPLAN_RESPONSE: "SUBSCRIPTIONPLAN_RESPONSE",
    SUBSCRIPTIONPLAN_ERROR: "SUBSCRIPTIONPLAN_ERROR",

    // update
    SUBSCRIPTIONPLAN_EDIT_REQUEST: "SUBSCRIPTIONPLAN_EDIT_REQUEST",
    SUBSCRIPTIONPLAN_EDIT_RESPONSE: "SUBSCRIPTIONPLAN_EDIT_RESPONSE",
    SUBSCRIPTIONPLAN_EDIT_ERROR: "SUBSCRIPTIONPLAN_EDIT_ERROR",

    // delete
    SUBSCRIPTIONPLAN_DELETE_REQUEST: "SUBSCRIPTIONPLAN_DELETE_REQUEST",
    SUBSCRIPTIONPLAN_DELETE_RESPONSE: "SUBSCRIPTIONPLAN_DELETE_RESPONSE",
    SUBSCRIPTIONPLAN_DELETE_ERROR: "SUBSCRIPTIONPLAN_DELETE_ERROR",
  };
  